// src/pages/TeacherRegistration.js
import React, { useState } from "react";
import { Input, Button, Form } from "antd";
import axios from "axios";
import { toast } from "react-toastify";

const TeacherRegistration = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    experience: "",
    bio: "",
    cv: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignUp = async () => {
    const { firstName, lastName, email, phone, password, confirmPassword } =
      formData;

    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      return toast.error("Please fill in all required fields");
    }

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      const name = `${firstName} ${lastName}`;

      const res = await axios.post(
        "https://custom.dev-designversestudios.com/api/v1/user/register",
        {
          name,
          email,
          phone,
          password,
          role: "teacher",
          verificationMethod: "email",
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      console.log(res.data);
      toast.success("Teacher account created successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div
      className="  mention-font1"
      style={{ background: "#000", minHeight: "80vh", padding: "0px 20px" }}
    >
      <div
        style={{
          width: "50%",
          margin: "0px auto",
          padding: "20px",
          background: "#000",
          borderRadius: "8px",
        }}
      >
        <h2
          className="mention-font1"
          style={{
            color: "#e6be5d",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Teacher Account Request
        </h2>
        <Form layout="vertical">
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                First Name
              </span>
            }
          >
            <Input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="John"
              className="mention-font12"
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Last Name
              </span>
            }
          >
            <Input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Doe"
              className="mention-font12"
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Email
              </span>
            }
          >
            <Input
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="john@example.com"
              className="mention-font12"
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Subject
              </span>
            }
          >
            <Input
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Enter the Subject"
              className="mention-font12"
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Short Bio
              </span>
            }
          >
            <textarea
              name="bio"
              value={formData.bio}
              onChange={handleChange}
              placeholder="Enter the Subject"
              className="mention-font12"
              style={{ borderRadius: "8px", width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Upload CV
              </span>
            }
          >
            <input
              type="file"
              name="cv"
              accept=".pdf,.doc,.docx"
              onChange={handleChange} // make sure your handleChange handles file: e.target.files[0]
              className="mention-font12"
              style={{
                borderRadius: "8px",
                width: "100%", // full width
                padding: "8px",
                border: "1px solid #d9d9d9",
              }}
            />
          </Form.Item>

          <Button
            type="primary"
            block
            className="mention-font12"
            onClick={handleSignUp}
            style={{
              background:
                "linear-gradient(to right, #fef3c7, #facc15, #fef3c7)",
              border: "none",
              color: "#1f2937",
              fontWeight: "600",
              height: "48px",
              borderRadius: "8px",
            }}
          >
            Register
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default TeacherRegistration;
